import React from 'react';
import ShopIcon from './../../../assets/images/ShopIcon.png'
import { Link, useNavigate } from 'react-router-dom';
import $ from "jquery";
import ShowPasswordClose from "./../../../assets/icons/show-password-icon-close.png";
import ShowPasswordOpen from "./../../../assets/icons/show-password-icon-open.png";
import logo from "./../../../assets/images/logo1.png";
import { useState } from 'react';
import moment from 'moment';
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import FooterContact from '../FooterContact';


var CryptoJS = require("crypto-js");

const StepOne = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [apiData, setApiData] = useState([]);

    let navigate = useNavigate();

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }


    // Generate Otp


    const [forgetPassword, setForgetPassword] = useState({
        otp: "",
        email: "",
        expire: ""
    });

    async function fetchData(param) {
        const exp = moment().add(10, "minutes").format("YYYY-MM-DD HH:mm:ss");

        await fetch(process.env.REACT_APP_API_BASE_URL + process.env.REACT_APP_API_PREFIX + "panel/forget-password/check-email", {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),

            body: JSON.stringify({
                email_address: param
            })

        }).then(res => res.json()).then(
            (result) => {
                setIsLoaded(true);
                setApiData(result);
                setEmail(param);

                const otp = result?.data?.otp;
                setForgetPassword({
                    email: email,
                    otp: otp,
                    expire: exp
                });

            },
            (error) => {
                setIsLoaded(true);
                setError(error);
            }
        );
    }


    useEffect(() => {
        window.history.replaceState({}, "");

        if (isLoaded === true) {
            if (error) {
                toast.error(error.messages.toString());
                return;
            }

            let response = JSON.stringify(apiData);
            response = JSON.parse(response);

            if (response["code"] === 200) {
                let token = CryptoJS.AES.encrypt(JSON.stringify(forgetPassword), process.env.REACT_APP_SECURITY_SALT).toString();
                window.localStorage.setItem("fp", token);
                navigate("/forget-password-step-two");
                return;
            }

            toast.error(response["messages"].toString());
        }

    }, [apiData]);


    const handleSubmit = event => {
        event.preventDefault();


        setError(null);

        if (!isValidEmail(email)) {
            toast.error('Email is invalid');
            return
        }
        
        fetchData(email);
    }

    const handleChange = (event) => {
        setEmail(event.target.value);
    }

    // Button opacity control on input filled

    $("input[type='email']").on("input", function () {
        $('.btn').css({ opacity: '0.6' });
        $('.btn').attr("disabled", true);

        let email = $(this).val();
        if(isValidEmail(email)) {
            $('.btn').css({ opacity: '1' });
            $('.btn').attr("disabled", false);
        }
    });




    return (
        <section className="h-screen bg-white font-murecho">
            <ToastContainer />
            <div className="h-full justify-center">
                {/* <!-- Left column container with background--> */}


                <div className='flex justify-center'>
                    <img src={logo} alt="" className='absolute top-12' />
                </div>


                <div
                    className="g-6 flex h-full flex-wrap items-center justify-center lg:justify-center">
                    <div
                        className="shrink-1 mb-12 grow-0 basis-auto md:mb-0 ">
                        <img
                            src={ShopIcon}
                            className="hidden mb-10 lg:block"
                            alt="ShareTrip Partner Portal" />

                    </div>

                    {/* <!-- Right column container --> */}
                    <div className="mb-12 md:mb-0 md:w-8/12 lg:w-5/12 xl:w-5/12">

                        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">

                            <div className="w-full bg-[#1882FF] rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
                                <div className="p-6 sm:p-10">

                                    <p className='text-white text-xl'>Welcome to</p>

                                    <p className="text-xl mb-4 font-semibold leading-8 text-white md:text-[28px] dark:text-white">
                                        ShareTrip Partner Portal
                                    </p>

                                    <p className='text-white font-medium text-sm mb-6'>Enter your email address</p>

                                    <form onSubmit={handleSubmit} method="POST">
                                        <div className='mb-5'>
                                            <input type="email" name="email" value={email} onChange={handleChange} autoComplete='off' id="email" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="E-mail" required="" />
                                        </div>

                                        <button className="btn w-full mb-3 text-white bg-[#003897] hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg px-6 py-3 text-center opacity-60">Next</button>

                                        <p className='text-white text-sm text-right'>Remember your password?<Link to="/" className="text-sm font-medium text-white text-right ml-1">Back to Login</Link></p>
                                    </form>
                                </div>
                            </div>

                            <FooterContact />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default StepOne;